/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { TextField } from "@mui/material";
import { isStringNotEmpty, isNumberInteger, isStringEmpty } from "utils/empty-exists";

const SetImageDimension = (props) => {
    
    const {
        selectDimension,
        dimension,
        whichDimension,
        width,
        height,
    } = props || {};
    
    const onChangeDimension = (event) => {
        let value = event.target.value;
        if (!value || isStringEmpty(value)) {
            value = whichDimension === "Width" ? width : height;
        }
        const amount = Number(value);
        selectDimension(amount);
    };
    
    return (
        <>
            <div className='component-box in-page-scale-methods-dimension'>
                {isStringNotEmpty(whichDimension) &&
                    <>
                        {isNumberInteger(dimension) &&
                            <>
                                <div className='component-labelField'>{whichDimension}:</div>
                                <TextField
                                    id='image-dimension'
                                    type='number'
                                    variant='outlined'
                                    value={dimension}
                                    onChange={onChangeDimension}
                                />
                            </>
                        }
                    </>
                }
            </div>
        </>
    );
};

export default SetImageDimension;
